module.exports = __webpack_public_path__ + "img/exe.a830f513.png";